// extracted by mini-css-extract-plugin
module.exports = {"incomeCalculatorRequiredQuestionOneText":"IncomeCalculator_incomeCalculatorRequiredQuestionOneText__A-zD0","margin_top":"IncomeCalculator_margin_top__WwdHy"};